import {
    faFileExcel,
    faFilePdf,
    faFileCsv,
    faFileExport,
    faFileAlt,
    faHistory,
    faSyncAlt,
    faQuestionCircle,
    faArrowLeft,
    faCheck,
    faLockAlt,
    faPen,
    faDollarSign,
    faCheckCircle,
    faTimesCircle,
    faCircle,
} from '@fortawesome/pro-regular-svg-icons'

export default [
    faFileExcel,
    faFilePdf,
    faFileCsv,
    faFileExport,
    faFileAlt,
    faHistory,
    faSyncAlt,
    faQuestionCircle,
    faArrowLeft,
    faCheck,
    faLockAlt,
    faPen,
    faDollarSign,
    faCheckCircle,
    faTimesCircle,
    faCircle,
]
